import { fg } from '@atlaskit/platform-feature-flags';

import { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStandardToPremium({
	product,
	config: { isPaidStandard },
	userRoles,
	paidEntitlement,
	trialOfferingName,
}: EditionAwarenessContextType): boolean {
	return !!(['confluence', 'jira', 'jira-service-management'].includes(product) &&
	isPaidStandard &&
	userRoles?.includes('SITE_ADMIN') &&
	fg('edition_awareness_upsell_custom_ea_implementation')
		? trialOfferingName === 'premium'
		: paidEntitlement?.isInvoiceable && paidEntitlement?.canUpgrade);
}
